import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
    price_time_box: {
        width: '328px',
        borderRadius: '8px',
        boxShadow: '0px 5px 15px rgba(54, 79, 81, 0.2)',
    },
}));